import { api } from "@/lib/api";

export const registerSW = async () => {
  if (!("serviceWorker" in navigator)) return null;
  try {
    return await navigator.serviceWorker.register("/sw.js");
  } catch {
    return null;
  }
};

const urlB64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
};

// Subscribe to Web Push and register with the backend scheduler
export const enablePush = async ({ lat, lng, rain, accessible }) => {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return false;
  const reg = (await navigator.serviceWorker.getRegistration()) || (await registerSW());
  if (!reg) return false;

  const { data } = await api.get("/push/vapid-public");
  if (!data.public_key) return false;

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(data.public_key),
    });
  }
  await api.post("/push/subscribe", {
    subscription: sub.toJSON(),
    tz_offset: new Date().getTimezoneOffset(),
    lat: lat ?? 30.6146,
    lng: lng ?? -96.3417,
    rain: !!rain,
    accessible: !!accessible,
  });
  return true;
};

export const disablePush = async () => {
  const reg = await navigator.serviceWorker?.getRegistration?.();
  const sub = await reg?.pushManager?.getSubscription?.();
  if (sub) {
    await api.post("/push/unsubscribe", { endpoint: sub.endpoint }).catch(() => {});
  }
};
